import { usersImportNavItem, usersNavItem } from './users/routes';
import { brokerGroupsNavItem } from './brokerGroups/routes';
import { featureFlagsNavItem } from './featureFlags/routes';
import { formFieldConfigsNavItem } from './formFieldConfigs/routes';
import { clientsNavItem } from './clients/routes';
import { claimsNavItem } from './claims/routes';
import { importsNavItem } from './imports/routes';

/**
 * Admin side nav sections, in nav order. A section without a title has no heading.
 */
export const adminNavSections = [
	{ items: [usersNavItem, brokerGroupsNavItem, featureFlagsNavItem, formFieldConfigsNavItem] },
	{
		title: 'Import',
		items: [usersImportNavItem, clientsNavItem, claimsNavItem, importsNavItem],
	},
];
